<template>
	<div class="landing--wrapper">
		<div v-if="recentPage == 1">
			<div class="section--wrapper">
				<div class="img--wrapper">
					<img class="landing-img" alt="Islamic audio and podcast, Welcome to Islamic, Learn about Islamic with Audio and Podcast" src="../assets/undraw/landing-page-1.webp">
				</div>
				<div class="txt--wrapper">
					<div class="title">Welcome to Islamic</div>
					<div class="subtitle">Learn about Islamic with Audio and Podcast</div>
					<div class="btn--wrapper">
						<button class="btn" v-ripple @click="show = !show" v-on:click="recentPage = 2">Get Started</button>
					</div>
				</div>
			</div>
		</div>
		<transition name="slide-fade">
			<div v-if="recentPage == 2">
				<div v-if="show"><!-- Animation --></div>
				<div class="section--wrapper">
					<div class="img--wrapper">
						<img class="landing-img" alt="Islamic audio and podcast, Discover Podcasts You'll Love, Listen about what you're interested in from Creators you love and stay in it." src="../assets/undraw/landing-page-2.webp">
					</div>
					<div class="txt--wrapper">
						<div class="title">Discover Podcasts You'll Love</div>
						<div class="subtitle">Listen about what you're interested in from Creators you love and stay in it.</div>
						<div class="btn--wrapper">
							<button class="btn" v-ripple @click="show = !show" v-on:click="recentPage = 3">Next</button>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<transition name="slide-fade">
			<div v-if="recentPage == 3">
				<div v-if="show"><!-- Animation --></div>
				<div class="section--wrapper">
					<div class="img--wrapper">
						<img class="landing-img" alt="Islamic audio and podcast, Made for Creators, Start upload an Audio to share some knowledge and advice." src="../assets/undraw/landing-page-3.webp">
					</div>
					<div class="txt--wrapper">
						<div class="title">Made for Creators</div>
						<div class="subtitle">Start upload an Audio to share some knowledge and advice.</div>
						<div class="btn--wrapper">
							<button class="btn" v-ripple @click="show = !show" v-on:click="recentPage = 4">Next</button>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<transition name="slide-fade">
			<div v-if="recentPage == 4">
				<div v-if="show"><!-- Animation --></div>
				<div class="section--wrapper">
					<div class="img--wrapper">
						<img class="landing-img" alt="Islamic audio and podcast, Listen Wherever You Are, Play all your favorite Creators audio & podcasts and gain some knowledge and advice from it" src="../assets/undraw/landing-page-4.webp">
					</div>
					<div class="txt--wrapper">
						<div class="title">Listen Wherever You Are</div>
						<div class="subtitle">Play all your favorite Creators audio & podcasts and gain some knowledge and advice from it</div>
						<div class="btn--wrapper">
							<button class="btn" v-ripple @click="show = !show" v-on:click="recentPage = 5">Next</button>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<transition name="slide-fade">
			<div v-if="recentPage == 5">
				<div v-if="show"><!-- Animation --></div>
				<div class="section--wrapper">
					<div class="img--wrapper">
						<img :class="($store.state.mode === 'dark') ? 'dark' : 'false'" class="logo" alt="Islamic audio and podcast, Sharing & Listening, Islamic content only." src="../assets/logo/icon.png">
					</div>
					<div class="txt--wrapper">
						<div class="title">Islamic</div>
						<div class="subtitle">an audio and podcast</div>
						<div class="signin--wrapper" v-ripple @click="signIn">
							<img alt="Islamic audio and podcast, sign in Google" src="../assets/icons/google.png"/>
							<span>Continue with Google</span>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
import firebase from 'firebase'
import db from '@/db'
export default {
	name : 'LandingPage',
	data() {
		return {
			recentPage : 1,
			show : true // animation
		}
	},
	methods : {
		signIn() {
			// eslint-disable-next-line
			let _this = this;
			let GoogleAuthProvider = new firebase.auth.GoogleAuthProvider()
			firebase.auth().signInWithPopup(GoogleAuthProvider).then(function(result) {
				// This gives you a Google Access Token. You can use it to access the Google API.
				//var token = result.credential.accessToken;
				// The signed-in user info.
				var user = result.user;
				db.collection('users').doc(user.uid).set({
					last_sign_in : new Date()
				},{ merge: true });
				// console.log(user)
				// _this.$message({
				// 	message : 'Welcome to JiTube ' + user.displayName,
				// });
				_this.$store.commit('setCurrentUser',user)
				_this.$router.push('/')
			}).catch(function() {
				// Handle Errors here.
				//var errorCode = error.code;
				// var errorMessage = error.message;
				// // The email of the user's account used.
				// //var email = error.email;
				// // The firebase.auth.AuthCredential type that was used.
				// //var credential = error.credential;
				// _this.$message({
				// 	message : errorMessage,
				// 	iconClass : 'el-icon-error'
				// });
			});
		}
	}
};
</script>
<style lang="scss" scoped>
$base-color: #1b7b46;
* {
	margin: 0;
	padding: 0;
}
/* Slide animation */
.slide-fade-enter-active {
	transition: all .35s;
}
.slide-fade-enter, .slide-fade-leave-to {
	transform: translateX(100px);
	opacity: 0;
}
.landing--wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	padding: 2rem;
	height: 100vh;
	.section--wrapper {
		height: 100vh;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-around;
		flex-flow: column;
		.img--wrapper {
			display: flex;
			justify-content: center;
			padding: 2rem;
			.landing-img {
				width: 75%;
			}
			.logo.false {
				background: rgba(0,0,0, .75);				
			}
			.logo {
				background: rgba(255,255,255, .03);
				border-radius: 50%;
				padding: 1.5rem;
				width: 15rem;
			}
		}
		.txt--wrapper {
			padding: 1rem;
			.title {
				font-size: 24px;
				margin-bottom: .35rem;
			}
			.subtitle {
				font-size: 12px;
				opacity: .7;
				letter-spacing: .01rem;
			}
			.signin--wrapper {
				display: flex;
				justify-content: space-evenly;
				align-items: center;
				flex-wrap: wrap;
				margin-top: 1.75rem;
				font-size: 12px;
				img {
					width: 12%;
				}
			}
			.btn--wrapper {
				margin-top: 1.75rem;
				.btn {
					cursor: pointer;
					font-size: 12px;
					letter-spacing: .02rem;
					width: 7rem;
					height: 2.75rem;
					color: white;
					border-radius: 14px;
					border: none;
					outline: none;
					transition: .25s;
					font-family: 'GoogleSans';
					background: rgba($base-color, 1);
					box-shadow: 0px 20px 40px -14px rgba($base-color, .9);
				}
				.btn:active {
					transform: scale(.95,.95);
				}
			}
		}
	}
}
@media only screen and (max-width: 600px) {
	.landing--wrapper {
		padding: 2rem 1rem;
	}
	.img--wrapper {
		padding: 0 !important;
		.landing-img {
			width: 100% !important;
			margin-bottom: 3rem
		}
	}
}
</style>
